/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

type Props = {
  title?: React.ReactNode;
  children: React.ReactNode;
  spacing?: number;
};

const styles = {
  subsection: (_: Theme, spacing?: number) => css`
    padding: ${spacing ? `${spacing}px` : 'var(--cds-spacing-200)'} 0 var(--cds-spacing-200);
  `,
  subsectionTitle: () => css`
    padding: 0 0 var(--cds-spacing-200) 0;
  `,
};

const Subsection = ({ title, children, spacing }: Props) => {
  const theme = useTheme();
  return (
    <div css={styles.subsection(theme, spacing)}>
      {title && <div css={styles.subsectionTitle}>{title}</div>}
      {children}
    </div>
  );
};

export default Subsection;
